<template>
  <div id="login-form-online" data-component="login-form-online">
    <KmOfflineLoginWalkThrough @guide-user-sign-in="guideUserSignIn"/>
    <b-card>
      <form name="form" method="POST" :action="backendUrl+'/callback?client_name=FormClient'">
        <!-- error section todo: refactor -->
        <div
          class="alert alert-danger"
          role="alert"
          v-if="err.includes('username')"
        >
          Username is required!
        </div>
        <div
          class="alert alert-danger"
          role="alert"
          v-else-if="err.includes('password')"
        >
          Password is required!
        </div>

        <!-- username input field -->
        <div class="form-group">
          <label for="username" class="a11y-hide">{{
            $t("login.username.$")
          }}</label>
          <input
            ref="username"
            type="text"
            class="form-control"
            name="username"
            id="username"
            :placeholder="$t('login.username.placeholder')"
            v-model="user.username"
          />
        </div>
        <!-- password input field -->
        <div class="form-group">
          <label for="password" class="a11y-hide">{{
            $t("login.password.$")
          }}</label>
          <input
            type="password"
            ref="password"
            :placeholder="$t('login.password.placeholder')"
            class="form-control mb-0"
            name="password"
            id="password"
            v-model="user.password"
          />
        </div>
        <!-- forgot password link -->
        <div>
          <b-button
            id="forgot-pwd-btn"
            variant="link"
            class="m-0 p-0 mb-4"
            @click="forgetPassword"
            >{{ $t("login.password.forgot") }}</b-button
          >
        </div>
        <!-- login button -->
        <div class="form-group">
          <button
            id="login-btn"
            class="btn btn-primary btn-block"
            :disabled="loading"
          >
            <span
              class="spinner-border spinner-border-sm"
              v-show="loading"
            />
            {{ $t("login.enter-button") }}
          </button>
        </div>
        <!-- error section -->
        <div class="form-group error">
          <div v-if="message">
            {{ message }}
            <div v-if="message == 'timedOut'">{{ timeOutMessage() }}</div>
          </div>
        </div>
        <template v-if="false">
          <div class="or-separator">
            <span class="or-text">
              OR
            </span>
          </div>
          <div>
            <button
              id="oidc-btn"
              class="btn btn-primary btn-block"
              :disabled="loading"
              @click.prevent="openIdConnect"
            >
              <span
                class="spinner-border spinner-border-sm"
                v-show="loading"
              />
              Open ID Connect
            </button>
          </div>
        </template>
      </form>
    </b-card>
  </div>
</template>

<script>
//---- components ---------
import KmOfflineLoginWalkThrough from "./KmOfflineLoginWalkThrough.vue"
//---- mixins -------------
import LoginFormMixin from "./LoginFormMixin.js"
//---- services -----------
//---- other --------------
//---- 3rd-parties --------

export default {
  name: "loginFormOnline",

  components: {KmOfflineLoginWalkThrough},
  mixins: [LoginFormMixin],

  mounted() {
    const usernameFromUrl = this.$route.query.user || this.$route.query.username;
    if (usernameFromUrl)
      this.user.username = usernameFromUrl;
  },

};
</script>

<style scoped>
#forgot-pwd-btn {
  font-size: .9rem;
}

.or-separator {
  line-height: 0;
  text-align: center;
  border-bottom: 1px solid gray;
  margin: 2rem -30px;
}
.or-text {
  background-color: white;
  padding: 1rem;
  text-align: center;
  color: gray;
}
</style>